import { render, staticRenderFns } from "./SelectPayment.vue?vue&type=template&id=396a5830"
import script from "./SelectPayment.vue?vue&type=script&lang=js"
export * from "./SelectPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports